import { useContext, useEffect, useState } from 'react';
import DigibookContext from '../_contexts/DigibookContext';
import { MaterialDataContext } from '../_contexts/MaterialDataProvider';
import { Digibook } from '../_api/DigibookApi';
import AccountContext from '../../../contexts/AccountContext';

type CodexDrawerMode = 'notes' | 'whitepages';

export default function useDigibook() {
  const { REACT_APP_CODEX_PLATFORM_TEMPLATE_URL } = process.env;

  const { digibook } = useContext(DigibookContext);
  const { selectedViewMode, selectedNodeIds, selectedExerciseSection } = useContext(MaterialDataContext);
  const { account } = useContext(AccountContext);

  const selectedNodeId = selectedNodeIds[selectedNodeIds.length - 1];

  const [pageRange, setPageRange] = useState<Digibook['pageRanges'][0]>();

  useEffect(() => {
    if (!digibook) return;

    if (selectedViewMode === 'exercise' && selectedExerciseSection !== 'chapter') {
      return setPageRange(undefined);
    }

    const range = digibook.pageRanges.find(pageRange => pageRange.nodeId === selectedNodeId);

    setPageRange(range);
  }, [digibook, selectedExerciseSection, selectedNodeId, selectedViewMode]);

  const buildCodexUrl = ({
    digibookId,
    moduleId,
    page,
    drawerMode,
    whitepageId,
  }: {
    digibookId: string;
    moduleId: string;
    page?: number;
    drawerMode?: CodexDrawerMode;
    whitepageId?: string;
  }) => {
    const provider = account.provider || 'pelckmans';

    const url = REACT_APP_CODEX_PLATFORM_TEMPLATE_URL.replace(':provider', provider)
      .replace(':id', digibookId)
      .concat(page ? `/${page}` : '');

    const q = new URLSearchParams({
      superModuleId: moduleId,
      ...(drawerMode ? { openDrawer: drawerMode } : undefined),
      ...(drawerMode === 'whitepages' && whitepageId ? { openWhitepage: whitepageId } : undefined),
    });

    return `${url}?${q}`;
  };

  return {
    buildCodexUrl,
    digibook,
    pageRange,
    pageNumber: pageRange?.from ?? 0,
  };
}
